// extracted by mini-css-extract-plugin
export var columnsContainer = "index-module--columnsContainer--cWpD6";
export var column = "index-module--column--JffMY";
export var icon = "index-module--icon--MYHsK";
export var info = "index-module--info--WmbhO";
export var title = "index-module--title--aMVKy";
export var description = "index-module--description--2WC3v";